import { action, props } from 'ts-action';
import { Cluster } from '../clustering.types';

export const load = action(
  '[Morphology] load',
  props<{ morphologies: Cluster[] }>(),
);

export const replaceMorphology = action(
  '[Morphology] replaceMorphology',
  props<{ newMorphology: Cluster; oldMorphology: Cluster | null }>(),
);

export const removeMorphology = action(
  '[Morphology] removeMorphology',
  props<{ morphology: Cluster }>(),
);
